let pending = null;

export function loadLearnsets() {
  if (!pending) {
    pending = fetch('/data/learnsets.json', { headers: { Accept: 'application/json' } })
      .then(async (response) => {
        const text = await response.text();
        if (!response.ok || text.trim().startsWith('<')) {
          throw new Error('The move list is not in this build yet.');
        }
        const data = JSON.parse(text);
        const idToIndex = {};
        (data.ids || []).forEach((id, index) => {
          idToIndex[id] = index;
        });
        return { ...data, idToIndex };
      })
      .catch((error) => {
        pending = null;
        throw error;
      });
  }
  return pending;
}

export function resetLearnsets() {
  pending = null;
}
